import { createContext } from 'react';
import SkillsData from '../data/skillsData';

const SkillsContext = createContext(SkillsData);

export default SkillsContext;